import { Environment } from './environment.dto';

export const environment: Environment = {
    isProduction: false,
    apiUrl: 'https://api-dev.votapp.app',
    server: {
        host: '127.0.0.1',
        port: 4001
    }
};
